<template>
    <section class="setting-profile-popup mfp-hide popup-save-document">
        <router-link :to="{ path: '/apps'}"  class="profile-edit-close-btn"><img src="/assets/img/close-icon.svg"/></router-link>
        <div class="setting-profile-wrapper">
            <div class="save-document-form">
                <h2>Documents Limit</h2>
                <p>You reached your plan's documents limit.<br/>
                Would you like to Upgrade your account?</p>
                <router-link :to="{ path: '/subscription-plans' }" class="btn btn-primary btn-rms-tx mr-0 mb-3 mx-auto">YES! Show me the plans</router-link>
                <div style="display:block;">
                    <router-link :to="{ path: '/apps' }" class="mx-auto underlined-link">No thanks, I'll try without it</router-link>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "DocumentLimitReached"
}
</script>

<style scoped>

</style>
